import {
  Button,
  Card,
  Col,
  Divider,
  Form, Image,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Upload
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {
  API_HOST_WEBSOCKET,
  API_IMG_UPLOAD
} from "../../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import React, {useEffect, useRef, useState} from 'react'
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import {getCategorieList, getMaterialList, getProductRecycleSave, getProductRecycleInfo} from "../../../constants/api";
import {removeToken} from "../../../utils/cookie";
import ImgCrop from "antd-img-crop";

import {COMMON_ROUTER} from "../../../constants";

const FormItem = Form.Item
const Option = Select.Option;
const formItemLayout = {
  labelCol: {
    xs: {span: 24},
    sm: {span: 8},
  },
  wrapperCol: {
    xs: {span: 24},
    sm: {span: 16},
  },
}
//根据官方属性定制化裁剪框大小固定的裁剪组件属性
const props = {
  width: 800,  //裁剪宽度
  height: 800, //裁剪高度
  rotate: true,
  zoom: true,
  resize: true, //裁剪是否可以调整大小
  resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
  modalTitle: "上传图片", //弹窗标题
  modalWidth: 900, //弹窗宽度
};


const useComponentWillMount = func => {
  const willMount = useRef(true);

  if (willMount.current) {
    func();
  }

  willMount.current = false;
};
/**
 * @Description: 动态获取原料子级数据
 * @Author Jiang
 * @Date 2020/7/26 14:08
 */


const EditRecycleGoods = ({location, history}) => {
  const [fileList, setFileList] = useState([])
  const [fileListSecond, setFileListSecond] = useState([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState([])
  const [isPutAway, setIsPutAway] = useState(1)
  const [xmCategory, setXmCategory] = useState([])
  const [xmCategoryId, setXmCategoryId] = useState(0)
  const [materialNames, setMaterialNames] = useState([])
  const [material, setMaterial] = useState([])
  const [materialIds, setMaterialIds] = useState(0)
  const [imageUrl, setImageUrl] = useState('')
  const [imageUrls, setImageUrls] = useState([])
  const [showImg, setShowImg] = useState(true)
  const [showImgSecond, setshowImgSecond] = useState(true)
  const formRef = React.useRef(null)
  const [loading, setLoading] = useState(false)
  const [uid, setUid] = useState('')
  const [isBarCodeChange, setIsBarCodeChange] = useState(0)

  useEffect(() => {
    getCategory();
    getGoodsInfo();
    getGoodsMaterial()
    /*if (fileListSecond) {
      let imagesTemp = [];
      fileListSecond.map((item, index) => {
        let resp = item.response
        if (resp &&  resp.code === 0) {
          let imgs = resp.data
          let im = {
            imageHash: imgs.imageUrl,
            imageUrl: imgs.imageUrl
          }
          imagesTemp.push(im)
        }
      })
      console.log(imagesTemp)
      setImageUrls([...imageUrls, ...imagesTemp])
    }*/
  }, [])
  //获取店铺品类
  const getCategory = () => {
    getCategorieList({
      pageIndex: 0,
      pageSize: 100,
      sortName: "",
      sortType: "descending",
      shopId: location.state.shopId,
      templateId: location.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          setXmCategory(data.data.records)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_CLASSIFY, {
    //   pageIndex: 0,
    //   pageSize: 100,
    //   sortName: "",
    //   sortType: "descending",
    //   shopId: location.state.shopId,
    //   templateId: location.state.templateId
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data.data);
    //     setXmCategory(data.data.records)
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }
  //获取商品详细信息
  const getGoodsInfo = () => {
    console.log(location.state.id)
    console.log(location.state.shopId)
    getProductRecycleInfo({
      id: location.state.id,
      shopId: location.state.shopId,
      templateId: location.state.templateId,
      platformType: location.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let goods = data.data
          let description = goods.description
          let imageUrl = goods.imageUrl
          setImageUrl(imageUrl)

          if (goods.imageUrls == null || goods.imageUrls == '') {
            setImageUrls([{imageHash: imageUrl, imageUrl: imageUrl}])
          } else {
            let imageUrlsTemp = JSON.parse(goods.imageUrls)

            let imageUrlMain = {imageHash: imageUrl, imageUrl: imageUrl}
            imageUrlsTemp.unshift(imageUrlMain)

            setImageUrls(imageUrlsTemp)
          }

          setIsBarCodeChange(goods.isBarCodeChange)
          let productName = goods.productName
          let xmCategoryId = goods.xmCategoryId
          let materials = JSON.parse(goods.materials)
          let materialsTemp = [];
          materials && materials.map((item, index) => {
            materialsTemp.push(item.name)
          })
          let specList = goods.specList
          let barCode = specList[0].barCode
          let onShelf = specList[0].onShelf
          let stock = specList[0].stock
          let weight = specList[0].weight
          let price = specList[0].price
          let shelfNumber = specList[0].shelfNumber
          console.log('------')
          console.log(onShelf)
          formRef.current.setFieldsValue({
            description: description,
            imageUrl: imageUrl,
            productName: productName,
            shelfNumber: shelfNumber,
            xmCategoryId: xmCategoryId,
            materialList: materialsTemp,
            productCode: barCode,
            isPutAway: onShelf,
            productStore: stock,
            productWeight: weight,
            productPrice: price,
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }


  /**
   * @Description: 获取商品原料
   * @Author Jiang
   * @Date 2020/7/26 11:55
   */
  const getGoodsMaterial = (parentId = 0, targetOption = {}) => {
    getMaterialList({
      parentId: parentId,
      platformType: location.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let materials = data.data
          if (parentId === 0) {
            materials.map((item, index) => {
              item['isLeaf'] = false
            })
            setMaterial(materials)
            console.log(materials)
          }
          if (parentId !== 0 && targetOption.lev === 1) {
            materials.map((item, index) => {
              item['isLeaf'] = false
            })
            targetOption.children = materials
            setMaterial([...material])
          }
          if (parentId !== 0 && targetOption.lev === 2) {
            materials.map((item, index) => {
              item['isLeaf'] = true
            })
            targetOption.children = materials
            setMaterial([...material])
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_MATERIAl, {
    //   parentId: parentId,
    //   platformType: location.state.platformType
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let materials = data.data
    //       if (parentId === 0) {
    //         materials.map((item, index) => {
    //           item['isLeaf'] = false
    //         })
    //         setMaterial(materials)
    //         console.log(materials)
    //       }
    //       if (parentId !== 0 && targetOption.lev === 1) {
    //         materials.map((item, index) => {
    //           item['isLeaf'] = false
    //         })
    //         targetOption.children = materials
    //         setMaterial([...material])
    //       }
    //       if (parentId !== 0 && targetOption.lev === 2) {
    //         materials.map((item, index) => {
    //           item['isLeaf'] = true
    //         })
    //         targetOption.children = materials
    //         setMaterial([...material])
    //       }
    //     }
    //   }
    // })
  }


  const onImgChangeSecond = ({fileList, file}) => {
    if (file.status == 'done') {
      if (file.uid != uid) {
        setUid(file.uid)
        const res = file.response;
        if (res.code === 0) {
          let img = res.data.imageUrl
          let obj = {imageUrl: img, imageHash: img};
          if (imageUrls) {
            setImageUrls([...imageUrls, obj])
          } else {
            setImageUrls([...obj])
          }

          message.success('上传成功', 1)
        }
      }
    }
    // setFileListSecond(fileList)
    setFileListSecond(fileList)

  };


  //base64图片文件
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
//图片预览取消函数
  const handleCancel = () => setPreviewVisible(false);

//图片预览弹窗函数
  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewVisible(true);
    setPreviewImage(file.url || file.preview)
  };
  const beforeUpload = (file) => {
    //限制图片 格式、size、分辨率
    const isJPG = file.type === 'image/jpeg';
    const isJPEG = file.type === 'image/jpeg';
    const isGIF = file.type === 'image/gif';
    const isPNG = file.type === 'image/png';
    if (!(isJPG || isJPEG || isGIF || isPNG)) {
      Modal.error({
        title: '只能上传JPG 、JPEG 、GIF、 PNG格式的图片~',
      });
      return;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      Modal.error({
        title: '超过5M限制，不允许上传~',
      });
      return;
    }
    return (isJPG || isJPEG || isGIF || isPNG) && isLt2M && checkImageWH(file);
  }

//返回一个 promise：检测通过则返回resolve；失败则返回reject，并阻止图片上传
  const checkImageWH = (file) => {
    return new Promise(function (resolve, reject) {
      let filereader = new FileReader();
      filereader.onload = e => {
        let src = e.target.result;
        const image = new Image();
        image.onload = function () {
          // 获取图片的宽高，并存放到file对象中
          file.width = this.width;
          file.height = this.height;
          resolve();
        };
        image.onerror = reject;
        image.src = src;
      };
      filereader.readAsDataURL(file);
    });
  }

//上传文件改变时的状态，详情可以参考antd的Upload组件API参数
  const onImgChange = ({fileList, file, event}) => {
    setFileList(fileList)
    setShowImg(false)
    console.log(fileList)
  };

  //选择分类
  const changexmCategoryId = (value) => {
    setXmCategoryId(value)
  }

  //请求添加商品
  const onFinish = (values) => {
    setLoading(true)
    //分类ID
    let xmCategoryId = values.xmCategoryId
    //商品描述
    let description = values.description
    //商品名称
    let productName = values.productName
    //货架号
    let shelfNumber = values.shelfNumber

    // if (!fileList) {
    //   message.error('请添加主图', 1)
    //   return
    // }
    // let imageUrlTemp = ''
    // if (showImg) {
    //   imageUrlTemp = imageUrl
    // } else {
    //   let file = fileList[0];
    //   let res = file.response;
    //   //主图
    //   if (res.code === 0) {
    //     let img = res.data
    //     imageUrlTemp = img.imageUrl
    //   }
    // }

    if (imageUrls.length < 1) {
      message.error('请添加主图', 1)
      return
    }
    let imageUrlTemp = ''
    let imagesSecond = []
    imageUrls.map((item,index)=>{
      if (index === 0) {
        imageUrlTemp = item.imageUrl
      } else {
        imagesSecond.push(item)
      }
    })


    //条形码
    let barCode = values.productCode
    //重量
    let weight = values.productWeight
    //价格
    let price = values.productPrice
    //库存
    let stock = values.productStore
    if (stock < 0 || stock > 99999) {
      message.error('库存范围为0~99999', 1)
      return
    }
    //是否上架
    let onShelf = values.isPutAway
    //保存商品

    getProductRecycleSave({
      description: description,
      imageUrl: imageUrlTemp,
      imageHash: imageUrlTemp,
      unit: '束',
      images: imagesSecond,
      productName: productName,
      productId: location.state.id,
      shopId: location.state.shopId,
      templateId: location.state.templateId,
      xmCategoryId: xmCategoryId,
      specList: [{
        barCode: barCode,
        weight: weight,
        price: price,
        stock: stock,
        onShelf: onShelf,
        shelfNumber: shelfNumber,
      }],
      minPurchaseQuantity: 1,
      materialList: [{name: "", id: 0}]
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data.dataHandleStatus === 0) {
            useWebSocketSync(data.data.messageKey)
          } else {
            setLoading(false)
            message.success('编辑成功', 1, () => {
              history.push({
                    pathname: COMMON_ROUTER + '/recycle',
                    state: {
                      tempCategoryId: location.state.tempCategoryId
                    }
                  }
              )
            })
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
          setLoading(false)
        } else {
          setLoading(false)
          message.error(data.msg)
        }
      }
    }).catch(error => {
      setLoading(false)
      message.error(error.toString())
    })
  }

  const useWebSocketSync = (key) => {
    setLoading(true)
    let url = "wss://" + API_HOST_WEBSOCKET + "/websocket/message/" + key;//服务端连接的url
    createWebSocket(url)
    //在组件卸载的时候，关闭连接
    return () => {
      closeWebSocket();
    }
  }
  let websocket, lockReconnect = false;
  let createWebSocket = (url) => {
    websocket = new WebSocket(url);
    websocket.onopen = function () {
      heartCheck.reset().start();
    }
    websocket.onerror = function () {
      reconnect(url);
    };
    websocket.onclose = function (e) {
      console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
    }
    websocket.onmessage = function (event) {
      console.log(event.data)
      if (event.data === '连接成功') {
        lockReconnect = true;
        setLoading(false)
      } else if (event.data == 'HeartBeat') {

      } else {
        let data = JSON.parse(event.data)
        lockReconnect = true;
        //event 为服务端传输的消息，在这里可以处理
        if (data.dataHandleStatus === 1) {
          history.push({
              pathname: COMMON_ROUTER + '/recycle',
              state: {
                tempCategoryId: location.state.tempCategoryId
              }
            }
          )
          setLoading(false)
        }
      }

    }
  }
  let reconnect = (url) => {
    if (lockReconnect) return;
    //没连接上会一直重连，设置延迟避免请求过多
    setTimeout(function () {
      this.createWebSocket(url);
      lockReconnect = false;
    }, 4000);
  }
  let heartCheck = {
    timeout: 60000, //60秒
    timeoutObj: null,
    reset: function () {
      clearInterval(this.timeoutObj);
      return this;
    },
    start: function () {
      this.timeoutObj = setInterval(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常
        websocket.send("HeartBeat");
      }, this.timeout)
    }
  }
  //关闭连接
  let closeWebSocket = () => {
    websocket && websocket.close();
  }

  //改变商品是否上架的状态
  const onChangeHot = (e) => {
    console.log(e)
    setIsPutAway(e.target.value)
  }
  /**
   * @Description: 返回
   * @Author Jiang
   * @Date 2020/9/7 10:39
   */
  const toBack = () => {
    history.push({
      pathname: COMMON_ROUTER + "/recycle",
      state: {
        tempCategoryId: location.state.tempCategoryId
      }
    })
  }

  /**
   * @Description: 删除副图
   * @Author Jiang
   * @Date 2020/9/18 14:57
   */
  const delImg = (index) => {
    console.log(index)
    let tempImgs = [];
    for (let i = 0; i < imageUrls.length; i++) {
      if (i !== index) {
        tempImgs.push(imageUrls[i])
      }
    }
    console.log(imageUrls)
    setImageUrls(tempImgs)
  }

  let isCalled = false, timer;
  const throttle = (functionTobeCalled, interval = 1000) => {
    if (!isCalled) {
      isCalled = true;
      clearTimeout(timer);
      timer = setTimeout(() => {
        isCalled = false;
      }, interval);
      return functionTobeCalled();
    }
  };

  return (
    <Form onFinish={onFinish} initialValues={{isPutAway: isPutAway}} ref={formRef}>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'top'}>
        <Col className={['gutter-row']} offset={6} span={2}>
          <div className='input-title'>基本信息</div>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='xmCategoryId' label="品类"
                    rules={[{required: true, message: '请选择品类',}]} {...formItemLayout}>
            <Select
              showSearch
              // defaultValue={this.state.shopSelectIds}
              value={xmCategoryId}
              style={{marginLeft: '20px'}}
              bordered={true}
              placeholder={'请选择品类'}
              onChange={changexmCategoryId}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {/*<Option value={0}>{'全部'}</Option>*/}
              {xmCategory && xmCategory.map((item) => {
                return <Option key={item.categorieId} value={item.categorieId}>{item.categorieName}</Option>
              })}
            </Select>
          </FormItem>
        </Col>
      </Row>
      {/* <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10} id={'materialList'}>
          <FormItem name='materialList' label="商品类目"
                    rules={[{required: true, message: '请选择商品类目',}]} {...formItemLayout}>
            <Cascader
              allowClear
              value={materialNames}
              fieldNames={{label: 'materialName', value: 'id',}}
              style={{marginLeft: '20px'}}
              options={material}
              loadData={(selectedOptions) => loadData(material, selectedOptions)}
              onChange={onMaterialChange}
              changeOnSelect
              getPopupContainer={() => document.getElementById('materialList')}
              placeholder={'请选择'}
            />
          </FormItem>
        </Col>
      </Row>*/}
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='productName' label="商品名称"
                    rules={[{required: true, message: '请输入商品名称',}]} {...formItemLayout}>
            <Input style={{marginLeft: "20px"}} maxLength = {50} placeholder="请输入商品名称"/>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='shelfNumber' label="发单价"
                    {...formItemLayout}>
            <Input style={{marginLeft: "20px"}} placeholder="请输入货架号"/>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='description' label="商品描述" {...formItemLayout}>
            <TextArea style={{marginLeft: "20px"}} maxLength = {250} placeholder={'请输入商品描述'} rows={4}/>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          <FormItem name='productCode' label="条形码"
                    rules={[{required: true, message: '请输入商品条形码',}]} {...formItemLayout}>
            {
              isBarCodeChange == 0 ?
                  <Input style={{marginLeft: "20px"}} disabled placeholder="请输入商品条形码"/>
                  :
                  <Input style={{marginLeft: "20px"}} placeholder="请输入商品条形码"/>
            }
          </FormItem>
        </Col>
      </Row>
      {/*<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">*/}
      {/*  <Col className='gutter-row' offset={6} span={10}>*/}
      {/*    {showImg ? <FormItem label="商品主图" labelCol={{span: 4}}*/}
      {/*                         {...formItemLayout}>*/}
      {/*      <div style={{width: '180px', marginLeft: "20px",}}>*/}
      {/*        <Image src={imageUrl}/>*/}
      {/*      </div>*/}
      {/*    </FormItem> : null}*/}
      {/*    <FormItem label="商品主图" labelCol={{span: 4}}*/}
      {/*              {...formItemLayout}>*/}
      {/*      <Upload*/}
      {/*        name="file"*/}
      {/*        action={API_IMG_UPLOAD}*/}
      {/*        data={{platformType: location.state.platformType}}*/}
      {/*        accept="image/*"*/}
      {/*        listType="picture"*/}
      {/*        fileList={fileList}*/}
      {/*        // beforeUpload={beforeUpload}*/}
      {/*        onPreview={handlePreview}*/}
      {/*        onChange={onImgChange}*/}
      {/*      >*/}

      {/*        {fileList && fileList.length >= 1 ? null : (<div className='img-container'>*/}
      {/*          <div>*/}
      {/*            <PlusOutlined style={{fontSize: "20px"}}/>*/}
      {/*            点击上传*/}
      {/*          </div>*/}
      {/*        </div>)}*/}
      {/*      </Upload>*/}

      {/*      <Modal visible={previewVisible} footer={null} onCancel={handleCancel} title='Image-Show'>*/}
      {/*        <img alt="example" style={{width: '100%'}} src={previewImage}/>*/}
      {/*      </Modal>*/}
      {/*    </FormItem>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={10}>
          {imageUrls.length > 0 && showImgSecond ? <FormItem label="商品图片" labelCol={{span: 4}}
                                                             {...formItemLayout}>
            <div style={{width: '180px', marginLeft: "20px"}}>
              {imageUrls && imageUrls.map((item, index) => {
                return (
                  <div key={index.toString()} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <Image style={{marginBottom: '20px', marginRight: "40px"}} src={item.imageUrl}/>
                    <div onClick={() => delImg(index)}>
                      <DeleteOutlined/>
                    </div>
                  </div>)
              })}
            </div>
          </FormItem> : null}
          <FormItem label="商品图片" labelCol={{span: 4}}
                    {...formItemLayout}>
            {/*<ImgCrop {...props}>*/}
            <Upload
              name="file"
              action={API_IMG_UPLOAD}
              data={{platformType: location.state.platformType}}
              accept="image/*"
              listType="picture"
              fileList={fileListSecond}
              showUploadList={false}
              // beforeUpload={beforeUpload}
              onPreview={handlePreview}
              onChange={onImgChangeSecond}
            >
              {imageUrls && imageUrls.length >= 6 ? null : (<div className='img-container' style={{marginLeft: 3}}>
                <div>
                  <PlusOutlined style={{fontSize: "20px"}}/>
                  点击上传
                </div>
              </div>)}
            </Upload>
            {/*</ImgCrop>*/}

            <Modal visible={previewVisible} footer={null} onCancel={handleCancel} title='Image-Show'>
              <img alt="example" style={{width: '100%'}} src={previewImage}/>
            </Modal>
          </FormItem>
        </Col>
      </Row>}
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
        <Col className='gutter-row' offset={6} span={20}>
          <Divider/>
        </Col>
      </Row>
      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align="top">
        <Col className={['gutter-row',]} offset={6} span={2}>
          <div className='input-title'>售卖规格</div>
        </Col>
        <Col className='gutter-row' span={12}>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' span={10}>
              <FormItem name='productPrice' label="价格"
                        rules={[{required: true, message: '请输入商品售价',}]} {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品售价"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' span={10}>
              <FormItem name='productWeight' label="重量"
                        {...formItemLayout}>
                <Input style={{marginLeft: "20px"}} placeholder="请输入商品重量"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' span={10}>
              <FormItem name='productStore' label="商品库存" hasFeedback={true}
                        rules={[{
                          required: true,
                          // message: '请输入商品库存',
                          validator: (rule, value, cbfn) => {
                            console.log(value)
                            if (value < 0 || value > 99999) {
                              cbfn("商品库存的范围在0~99999")
                            }
                            cbfn();
                          }
                        }]} {...formItemLayout}>

                <Input style={{marginLeft: "20px"}} placeholder="请输入商品库存"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} justify="middle">
            <Col className='gutter-row' offset={1} span={10}>
              <Form.Item label="是否上架" name='isPutAway'>
                <Radio.Group onChange={onChangeHot}>
                  <Radio value={1}>是</Radio>
                  <Radio value={2}>否</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>


      <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}} align={'middle'} justify={'center'}>
        <FormItem>
          <Button onClick={toBack}>返回</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" loading={loading} htmlType="submit" className="login-form-button">确认</Button>
        </FormItem>
      </Row>
    </Form>
  )
}

export default (props) => {
  return (
    <Card style={{width: '100%', overflow: "hidden", overflowY: "auto",}}>
      <EditRecycleGoods location={props.location} history={props.history}/>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/pages/recycle/edit-goods/index.jsx